module.exports = __webpack_public_path__ + "img/csr_111123_E.cfadcd20.jpg";